<template>
  <div id="app">
    <!-- v-if="!$store.state.waiting_for_data" -->
    <router-view />
    <Cookies color_one="#d89747" color_two="white" websitename="vie-economique-gimont.fr"></Cookies>
  </div>
</template>

<script>
import Cookies from '@/components/Cookies.vue';
export default {
  components: {
		Cookies,
	},
}
</script>

<style>
/* GENERAL */

/* Fonts */

@font-face {
  font-family: "Muti";
  src: url("./assets/fonts/Muli/Muli-VariableFont_wght.ttf");
}

@font-face {
  font-family: "Literata";
  src: url('./assets/fonts/Literata/Literata-VariableFont_wght.ttf');
}

:root {
  color-scheme: normal !important;
}

* {
  font-family: "Muti", Avenir, Helvetica, Arial, sans-serif;
}

h1,
h4,
h5,
h6 {
  font-family: "Literata", Avenir, Helvetica, Arial, sans-serif;
}

p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
li {
  color: #3c4652;
}

::-webkit-scrollbar {
  width: 10px;
  background-color: #fff;
}

::-webkit-scrollbar-track {
  background-color: #3c4652;
}

::-webkit-scrollbar-thumb {
  background-color: #d89747;
  border: 1px solid #d89747;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #d89747;
  border: 1px solid #d89747;
}

a {
  color: white;
  text-decoration: none;
  transition: all 0.5s ease;
}

i {
  cursor: pointer;
}

i.fa-globe:hover,
.fa-envelope:hover,
.fa-phone-alt:hover {
  color: #d89747;
  transition: all 0.5s ease;
}

body {
  margin: 0;
}

h1 {
  font-size: 2rem;
  text-align: center;
  margin: -1rem 0 3rem 0;
}

h2 {
  font-size: 1.2rem;
  text-align: center;
}

.phoneIcons {
    position: absolute;
    top: 0;
    right: 0;
    display: none;
}
.phoneIcons a {
    margin: 8px 8px 0 0;
}
.phoneIcons i {
    font-size: 2rem;
}
.phoneMenu {
    position: fixed;
    background-color: #3c4652;
    top: 0;
    bottom: 0;
    width: 100%;
    display: none;
    z-index: 999;
}
.phoneMenu nav {
  position: relative;
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.phoneMenu nav a {
  font-size: 1.5rem !important;
  margin-bottom: 2rem !important;
  border-bottom: 2px solid #d89747;
  padding-bottom: 1rem;
}
.phoneMenu .blackBtn {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0;
}
.phoneMenu > i.fa-times {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 1.6em;
  z-index: 1;
}
#hplHeaderNavPhoneToggle2 {
  float: right;
  margin: 1rem;
}
#hplHeaderNavPhoneToggle2 i {
  font-size: 2rem;
}

.locationSection input,
.searchBoxList input {
  padding: 0;
  height: 40px;
  padding-left: 8px;
  border: 1px lightgray solid;
  border-radius: 4px;
  min-width: 25vw;
}

.yellowBtn {
  background: #d89747;
  padding: 0.8rem 2rem;
  border-radius: 50px;
  color: white;
  text-transform: uppercase;
  height: fit-content;
  box-shadow: 0 0 0 2px #d89747;
  white-space: nowrap;
}

.yellowBtn:hover {
  background-color: #3c4652;
  transition: all 0.5s ease;
  cursor: pointer;
}

.blackBtn,
.RadButton {
  color: white;
  padding: 0.8rem 2rem;
  border: 1px solid #3c4652;
  border-radius: 50px;
  background-color: #3c4652;
  text-transform: uppercase;
  height: fit-content;
  white-space: nowrap;
}

.blackBtn:hover,
.RadButton:hover {
  background-color: #d89747;
  background-color: #d89747;
  color: white;
  transition: all 0.5s ease;
  cursor: pointer;
}

.mo {
  margin-left: 1rem;
}

i.fa-instagram:hover {
  color: #bc2a8d;
  transition: all 0.5s ease;
}

i.fa-twitter:hover {
  color: #00acee;
  transition: all 0.5s ease;
}

i.fa-facebook-f:hover {
  color: #4267b2;
  transition: all 0.5s ease;
}
i.fa-linkedin-in:hover {
  color: #0e76a8;
  transition: all 0.5s ease;
}

.firstDiv {
  padding-left: 15%;
  width: 45%;
  padding-top: 8%;
}

.firstDiv p {
  font-size: 1.5rem;
}

.firstDiv h3 {
  font-size: 2rem;
  color: #333;
  font-weight: 700;
}

.firstDiv a {
  width: fit-content;
  margin-top: 5rem;
  display: table;
}

.etapesDiv {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 50%;
  text-align: center;
}

.etapesDiv p {
  margin: 0;
  font-weight: bold;
}

.etapesDiv div {
  width: 45%;
}

.etapesDiv img {
  max-width: 100%;
}

/*itemsList;html*/
/*ET DETAIL*/

aside {
  background: url('/assets/img/content/Customer-Survey-bro.png') no-repeat
    center 30%;
  background-size: contain;
  background-color: #d89747;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

aside .logoLink img {
  width: 80%;
  margin-left: 10%;
}

aside > img {
  width: 116%;
  max-height: 44%;
  object-fit: contain;
}

aside nav {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

aside nav a {
  margin: 0.5rem 0;
}

aside nav .blackBtn {
  margin: 5rem 0;
}

aside nav .blackBtn:hover {
  box-shadow: 0 0 0 2px #3c4652;
}

.connectIco {
  display: none;
}

.mainSection {
  margin-left: 23%;
  margin-right: 5%;
}

.mainSection h2 {
  margin: 0;
  font-size: 1.5rem;
}

.mainSection header {
  background: none;
  justify-content: space-between;
  height: unset;
  align-items: flex-end;
  padding: 4rem 0 1rem;
  border-bottom: 1px #3c4652 solid;
}

.mainSection div label {
  display: block;
  margin-bottom: 0.3rem;
  color: #888;
}

.inputBox {
  border: 1px gray solid;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 15vw;
}

.inputBox input {
  height: 90%;
  width: 13vw;
}

.inputBox i {
  transform: rotate(90deg);
  margin: 4px 8px;
  color: gray;
}

.inputBox input {
  border: none;
}

.boutiquesContainer {
  display: flex;
  flex-wrap: wrap;
}

.boutiquesContainer article {
  width: 21%;
  margin: 2%;
}

.boutiquesContainer p {
  margin: 0;
}

.boutiquesContainer h4 {
  text-transform: uppercase;
  margin: 0;
  /* font-family: "Muti"; */
}

.boutiquesContainer .subtitle {
  color: #d89747;
}

.contactBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.btnMoreInfos {
  border: 2px #d89747 solid;
  border-radius: 4px;
  padding: 0.5rem 1.2rem;
  float: right;
}

.btnMoreInfos:hover {
  background-color: #f3d6b2;
}

.bo {
  font-weight: bold;
}

.mainSectionDetail {
  margin-left: 17%;
  display: flex;
}

.mainSectionDetail > * {
  width: 50%;
  height: 100%;
}

.produitsDiv {
  background-color: #f3d6b2;
}

.who {
  margin: 5rem 8% 0;
  border: 1px lightgray solid;
  border-radius: 8px;
  position: relative;
  text-align: center;
  padding: 1rem;
}

.who h2 {
  margin: 1rem 0 0;
}

.who img {
  position: absolute;
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 50%;
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%);
}

.who .adress {
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;
  border-bottom: 1px lightgray solid;
}

.who .adress p {
  margin: 0 8px;
}

.who .contactBox {
  justify-content: center;
  margin-top: 1rem;
}

.who .contactBox div {
  margin: 0 1rem;
}

.who .contactBox i {
  font-size: 1.7em;
}

.servicesBox {
  display: flex;
  justify-content: center;
  border: 1px lightgray solid;
  border-radius: 8px;
}

.servicesBox div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 0.8rem;
  color: #aaa;
  padding: 0.5rem 0.1rem;
  flex: 1;
  border-right: 1px lightgray solid;
}

.servicesBox div:last-child {
  border-right: none;
}

.servicesBox i {
  font-size: 2.2em;
  margin-bottom: 8px;
}

.servicesBox .fa-check-circle {
  color: #d89747;
}

.produitsDiv {
  padding: 1rem;
}

.head {
  display: flex;
}

.head h2 {
  text-align: left;
}

.head .left > div {
  width: fit-content;
  padding: 0.5rem;
}

.head > * {
  width: 50%;
}

.head > img {
  max-width: 100%;
}

.head label {
  color: #aaa;
  margin-bottom: 8px;
}

.head input {
  height: 40px;
  border: 1px lightgray solid;
  border-radius: 4px;
  padding-left: 1rem;
}

.prodList {
  display: flex;
  flex-wrap: wrap;
  margin-top: 2rem;
}

.prodList article {
  width: 31%;
  margin: 0 1% 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.prodList img {
  max-width: 100%;
  height: 150px;
  object-fit: cover;
}

.prodList a {
  margin: 1rem;
  text-decoration: underline;
  text-align: center;
}

textarea {
  height: 100px;
  width: 80%;
  border-radius: 8px;
  padding: 4px;
}

.validBtnContainer {
  margin: 2rem;
}

.validBtnContainer .yellowBtn {
  float: right;
}

/* MODAL INSCRIPTION PANEL*/
.inscriptionPanel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: white;
  z-index: 1000;
  overflow-x: scroll;
}

#connectUser,
#signInUser,
#signInUserCustomer,
#signInUserSeller {
  display: none;
}

.btnClose {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 2em;
  cursor: pointer;
}

.commercantPart {
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.commercantPart > img {
  max-width: 60%;
  height: auto;
  object-fit: contain;
}

.commercantPart p {
  font-size: 1.3rem;
  font-weight: 600;
}

.logoComm img {
  margin-left: 25%;
  max-width: 50%;
  margin-top: 2rem;
}

.formDiv {
  width: 65%;
  height: 100%;
}

.formDiv article {
  background-color: #f3d6b2;
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.formDiv h3 {
  color: #444;
  font-size: 2.5rem;
  margin: 0;
  margin-bottom: 1rem;
  text-align: center;
}

.formDiv h4 {
  font-size: 2.5rem;
  margin: 0 0 1rem 10%;
}

h4 small {
  font-size: 1.5rem;
}

.formDiv div {
  margin: 0 10%;
}
.formDiv div.box {
  display: flex;
}
.formDiv div.box > * {
  flex: 1;
}

.formDiv .boxCheckbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1rem;
}

.formDiv .boxCheckbox input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
}

.formDiv .boxCheckbox label {
  font-size: 1.2rem;
}

.formDiv label {
  display: block;
  margin: 1rem 0;
  font-size: 1.5rem;
  color: gray;
}

.formDiv::placeholder {
  color: lightgray;
}

.formDiv input[type="text"],
.formDiv input[type="password"] {
  height: 60px;
  width: 80%;
  padding: 0;
  padding-left: 10px;
  border: 1px lightgray solid;
  border-radius: 8px;
  font-size: 1.5rem;
}

::placeholder {
  color: #aaa;
  font-size: 1rem;
}

.formDiv .fullInput {
  width: 90%;
}

.formDiv .blackBtn {
  width: fit-content;
  margin-left: auto;
  margin-right: 3rem;
}

.dejaMembre {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
  color: #aaa;
  font-size: 1.2rem;
  height: 20%;
  margin: 0 10%;
  align-items: center;
}

.dejaMembre p > a {
  color: #777;
}

.dejaMembre p > a:hover {
  color: #3c4652;
}

.backBtn {
  border: 1px #ccc solid;
  border-radius: 50px;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #aaa;
  height: fit-content;
  cursor: pointer;
}

.backBtn:hover {
  color: #3c4652;
  border-color: #3c4652;
}

.backBlackBtn {
  border: 1px #3c4652 solid;
  border-radius: 50px;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #3c4652;
  height: fit-content;
  align-self: flex-start;
  margin: 1rem;
}

.backBlackBtn:hover {
  background-color: #3c4652;
  color: #d89747;
}


.passBox {
  display: flex;
}

.passBox > * {
  flex: 1;
}

.passBox input {
  width: 60%;
}

.rgpdBox {
  display: flex;
  align-items: center;
}

.rgpdBox input {
  height: 20px;
  width: 20px;
  margin-right: 1rem;
}

.blackCircles {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: -5rem;
}

.etapesPanel {
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.etapesPanel > img {
  max-width: 60%;
}

.bigcircle {
  background-color: #3c4652;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}

.bigcircle::after {
  margin-left: 40px;
  content: "Commander";
  line-height: 30px;
}

.smcA::after {
  margin-left: 40px;
  content: "Confirmer";
  line-height: 20px;
}

.smcB::after {
  margin-left: 40px;
  content: "Paiement";
  line-height: 20px;
}

.smcC::after {
  margin-left: 40px;
  content: "Livraison";
  line-height: 20px;
}

.trait {
  width: 2px;
  height: 40px;
  background: #3c4652;
}

.smcircle {
  background-color: #3c4652;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

/* Panel Errors/Success */
.errorpanel {
  background: white;
  position: fixed;
  top: 25%;
  left: 5%;
  right: 5%;
  z-index: 10;
  box-shadow: 0 0 8px 0 #bbb;
  text-align: center;
}

.errorpanel ul {
  list-style: none;
}

.errorpanel .error {
  padding: 1rem;
}

.errorpanel .close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-weight: bold;
}

.errorpanel .success {
  padding: 1rem;
}




/*************************
    MAX-WIDTH : 1200PX
*************************/
@media all and (max-width: 1200px) {
  /* GENERAL */
  .blackBtn,
  .RadButton {
    padding: 0.8rem 1rem;
  }

  /* HOME & ASIDE - CONNECT USER _ SIGN IN USER _ SIGN IN USER SELLER _ SIGN IN USER CUSTOMER */
  .formDiv {
    width: 70%;
  }
  .etapesPanel {
    width: 30%;
  }
  .etapesPanel > img {
    max-width: 80%;
  }
  .passBox input {
    width: unset;
  }
  .blackCircles {
    align-self: flex-start;
    margin-left: 4rem;
  }
}

/*************************
    MAX-WIDTH : 1100PX
*************************/
@media all and (max-width: 1100px) {
  /* HOME & ASIDE - CONNECT USER _ SIGN IN USER _ SIGN IN USER SELLER _ SIGN IN USER CUSTOMER */
  .formDiv h3 {
    font-size: 2rem;
  }
}

/*************************
    MAX-WIDTH : 1000PX
*************************/
@media all and (max-width: 1000px) {
  /* GENERAL */
  .backBlackBtn {
    position: absolute;
    left: 8px;
  }
  .phoneIcons {
    display: block;
    position: fixed;
    top: 10px;
    z-index: 999;
    font-size: 1.2rem;
  }
  #hplHeaderNavPhoneToggle1 {
    color: #3c4652;
  }

  /* HOME & ASIDE - CONNECT USER _ SIGN IN USER _ SIGN IN USER SELLER _ SIGN IN USER CUSTOMER */
  .inscriptionPanel {
    flex-direction: column;
  }
  .etapesPanel {
    flex-direction: row;
  }
  .commercantPart {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  .formDiv article {
    height: 100%;
  }
  .commercantPart > img {
    max-width: 30%;
  }
  .logoComm img {
    margin: 0;
    max-width: 300px;
  }
  .formDiv {
    width: 100%;
  }
  .blackCircles {
    display: none;
  }
  .etapesPanel {
    flex-direction: row;
    justify-content: space-evenly;
    width: 100%;
    height: 30%;
  }
  .etapesPanel > img {
    max-width: 60%;
  }
  .formDiv {
    height: unset;
  }
  .hideThousand {
    display: none;
  }
}

/*************************
    MAX-WIDTH : 768PX
*************************/
@media all and (max-width: 768px) {
  /* HOME & ASIDE - CONNECT USER _ SIGN IN USER _ SIGN IN USER SELLER _ SIGN IN USER CUSTOMER */
  .logoComm {
    display: none;
  }
  .passBox {
    flex-direction: column;
  }
  .passBox input {
    width: 80%;
  }
  #connectUser .etapesPanel {
    display: none;
  }
}

/*************************
    MAX-WIDTH : 500PX
*************************/
@media all and (max-width: 500px) {
  /* GENERAL */
  h1 {
    font-size: 1.3rem;
    margin-top: 1rem;
  }

  /* HOME & ASIDE - CONNECT USER _ SIGN IN USER _ SIGN IN USER SELLER _ SIGN IN USER CUSTOMER */
  .commercantPart > img {
    max-width: 100%;
  }
}
</style>
